function encodeBase64(value) {
  const bytes = new TextEncoder().encode(String(value))
  let binary = ""
  bytes.forEach((byte) => { binary += String.fromCharCode(byte) })
  return globalThis.btoa(binary)
}

function decodeBase64(value) {
  const normalized = String(value).replace(/-/g, "+").replace(/_/g, "/")
  const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, "=")
  const binary = globalThis.atob(padded)
  return new TextDecoder().decode(Uint8Array.from(binary, (character) => character.charCodeAt(0)))
}

export const Utils = {
  getPathname: () => window.location.pathname,
  reloadPage() {
    window.scrollTo({ top: 0 })
    window.location.reload()
  },
  reflow(element) {
    if (element) void element.offsetWidth
  },
  encode: encodeBase64,
  decode: decodeBase64,
  clone: (value) => JSON.parse(JSON.stringify(value)),
  repeat: (value, count) => value.repeat(count),
  numberToAlpha: (number) => String.fromCharCode("A".charCodeAt(0) + number - 1),
  isFullscreen: () => Boolean(document.fullscreenElement),
  generateToken() {
    const bytes = new Uint8Array(6)
    window.crypto.getRandomValues(bytes)
    return Array.from(bytes, (byte) => "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"[byte % 62]).join("")
  }
}

export function escapeHtml(value) {
  const element = document.createElement("div")
  element.textContent = value == null ? "" : String(value)
  return element.innerHTML
}
